<div class="button-grid">
  <div class="button-grid__item">
    <!-- Trip -->
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonBackground]="CardButtonBackground.Tertiary"
      [buttonIcon]="['fas', 'umbrella-beach']"
      (clicked)="searchTrip()">
      {{ 'webPos.Trip.TripRefundButton' | translate }}
    </app-card-button>
  </div>
  <div class="button-grid__item">
    <!-- Flight Ticket -->
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonBackground]="CardButtonBackground.Tertiary"
      [buttonIcon]="['fas', 'plane']"
      (clicked)="goToReturnFlyTicket()">
      {{ 'webPos.FlyTicketRefundButton' | translate }}
    </app-card-button>
  </div>
  <div class="button-grid__item">
    <!-- E-Travel Ticket -->
    <app-card-button
      [disabled]="false"
      [buttonSize]="CardButtonSize.Long"
      [buttonBackground]="CardButtonBackground.Tertiary"
      [buttonIcon]="['fas', 'earth-europe']"
      (clicked)="goToReturnETravelTicket()">
      {{ 'webPos.ETravelRefund' | translate }}
    </app-card-button>
  </div>
</div>
